import React from 'react';
import { PopupContainer } from '@src/emp-3.0/components/MappedEventBuilder/styled';
import Icon from '@ant-design/icons';
import WarnSvg from '@icons/warning.svg';
export const DuplicatePopupContent = ({
  duplicateMappedEventName,
  footer,
  text,
}: {
  duplicateMappedEventName: string;
  footer: React.ReactNode;
  text?: string;
}) => {
  return (
    <PopupContainer>
      <div className="popup-header" style={{ fontWeight: 400 }}>
        <span>
          <Icon component={WarnSvg} style={{ fontSize: '12px', marginRight: '8px' }} /> The current
          event rule is identical with the existing{' '}
          <span style={{ fontWeight: 500 }}>{duplicateMappedEventName}</span> rule.
          <br />
          Duplicate event rules are not allowed. {`${text || ''}`}
        </span>
      </div>

      <div className="popup-footer">{footer}</div>
    </PopupContainer>
  );
};
